<template src="./Complete.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("lookups/getLookups");
        this.$store.dispatch("lookups/getPaymentAccounts");

        this.$store
            .dispatch("treasury/getForComplete", this.itemId)
            .then((res) => {
                this.vm.patientName = res.patientsPayment.patientName;
                this.vm.doctorName = res.patientsPayment.doctorName;
                this.vm.patientPaymentType = res.patientsPayment.patientPaymentType;
                this.vm.appointmentDate = res.patientsPayment.appointmentDate;
                this.vm.amount = res.servicePrice;
            }).catch(() => { });
    },
    computed: {
        paymentTypes() {
            return this.$store.state.lookups.paymentAccounts;
        },
    },
    data() {
        return {
            vm: {
                amount: null,
                remark: null,
                paymentTypeId: null,
                referenceNo: null,
                patientName: null,
                doctorName: null,
                patientPaymentType: null,
                appointmentDate: null,
            },

            hasReference: false,

        };
    },
    methods: {
        changePaymentTypes() {
            this.hasReference = false;
            let paymentAccount = this.paymentTypes.find((x) => {
                if (x.value == this.vm.paymentTypeId) return x
            })
            this.hasReference = paymentAccount.hasReference;
        },
        confirm() {
            let vm = {
                doctorName: this.vm.doctorName,
                amount: this.vm.amount == null ? 0 :this.vm.amount ,
                paymentTypeId: this.vm.paymentTypeId,
                referenceNo: this.vm.referenceNo,
                remark: this.vm.remark,
            }
            this.$store
                .dispatch("treasury/complete", { id: this.itemId, payload: vm })
                .then(() => {
                    const routeData = this.$router.resolve(
                        `/receipt/${this.itemId}`
                    );
                    window.open(routeData.href, "_blank");
                    this.back();
                })
                .catch(() => { });
        },

        back() {
            this.$emit("back");
        },
    },
};
</script>